import React from 'react'
import MailIcon from '@mui/icons-material/MailRounded'
import { Tooltip } from '@mui/material'
import { HeaderIconButton } from './HeaderIconButton'

export interface MailUnreadButtonProps {
  count: number
  onClick: () => void
  tooltip: string
  badgeStyle?: React.CSSProperties
}

const MailUnreadButton: React.FC<MailUnreadButtonProps> = ({ count, onClick, tooltip, badgeStyle }) => {
  const badgeContent = count > 0 ? count : null

  return (
    <Tooltip title={tooltip}>
      <HeaderIconButton onClick={onClick} aria-label={tooltip} type="button">
        <MailIcon />
        {badgeContent !== null ? (
          <span className="HeaderBadge">
            <span className="BadgePill BadgePill--mail" style={badgeStyle} aria-live="polite">
              {badgeContent}
            </span>
          </span>
        ) : null}
      </HeaderIconButton>
    </Tooltip>
  )
}

export default MailUnreadButton
